export default __webpack_public_path__ + "static/media/hover1.7a0b5771.jpg";